customElements.component = "text-icons-grid";

class TextIconsGrid extends HTMLElement {
  constructor() {
    super();

    this.popup = this.querySelector(".text-icon-ds__popup-wrapper");
    this.openChatBtn = this.querySelector(this.dataset.triggerChat);
    this.openPopUpBtn = this.querySelector(this.dataset.triggerPopup);
    this.closePopUpBtn = this.querySelector(".text-icon-ds__popup-close-btn");
    this.body = document.querySelector("body");
  }

  openPopup() {
    this.popup.classList.add("active");
    this.body.classList.add("popup-open");
  }

  closePopup() {
    this.popup.classList.remove("active");
    this.body.classList.remove("popup-open");
  }

  openChat() {
    zE("messenger", "open");
  }

  addEventListeners() {
    this.openPopUpBtn.addEventListener("click", this.openPopup.bind(this));
    this.closePopUpBtn.addEventListener("click", this.closePopup.bind(this));
    this.openChatBtn.addEventListener("click", this.openChat.bind(this));
    this.popup.addEventListener("click", (e) => {
      if (!e.target.closest(".text-icon-ds__popup")) {
        this.closePopup().bind(this);
      }
    });
  }

  connectedCallback() {
    this.addEventListeners();
    if (this.querySelector(".form-success")) {
      this.openPopup.bind(this);
    }
  }
}

if (!customElements.get(customElements.component)) {
  customElements.define(customElements.component, TextIconsGrid);
}
